import type { Staff } from "@senciamatch/shared/models/staff";
import { Link } from "react-router-dom";
import { v7 as uuidv7 } from "uuid";

interface Props {
  staffs: Staff[];
  mutate: () => void;
}

export const StaffTable: React.FC<Props> = ({ staffs }) => {
  return (
    <div className="overflow-y-auto flex-grow">
      <table className="min-w-full">
        <thead className="sticky top-0 bg-gray-100">
          <tr className="bg-gray-100">
            <th className="p-2 text-left border border-gray-200">スタッフ番号</th>
            <th className="p-2 text-left border border-gray-200">氏名（漢字）</th>
            <th className="p-2 text-left border border-gray-200">氏名（カナ）</th>
            <th className="p-2 text-left border border-gray-200">住所</th>
            <th className="p-2 text-left border border-gray-200">備考</th>
            <th className="p-2 text-left border border-gray-200">在籍</th>
            <th className="p-2 text-left border border-gray-200">-</th>
          </tr>
        </thead>
        <tbody>
          {staffs.map((staff) => (
            <tr key={uuidv7()}>
              <td className="p-2 text-left border border-gray-200">{staff.id}</td>
              <td className="p-2 text-left border border-gray-200">{staff.name}</td>
              <td className="p-2 text-left border border-gray-200">{staff.nameKana}</td>
              <td className="p-2 text-left border border-gray-200">
                {staff.postalCode}
                <br />
                {staff.address}
                <br />
                最寄り駅: {staff.nearestStation}
              </td>
              <td className="p-2 text-left border border-gray-200">
                <p>
                  全日勤務時の深夜勤務可否: {staff.canWorkAtNight ? "可" : "不可"}
                  <br />
                  保険加入状況: {staff.isSocialInsurance ? "加入" : "未加入"}
                  <br />
                  防災センター要員 : {staff.isDisasterCenter ? "要員" : "-"}
                </p>
              </td>
              <td className="p-2 text-left border border-gray-200">{staff.isActive ? "在籍" : "退職"}</td>
              <td className="p-2 text-left border border-gray-200">
                <div className="flex flex-col gap-1">
                  <Link to={`/staffs/${staff.id}/edit`} className="text-primary-700">
                    編集
                  </Link>
                  <Link to={`/staffs/${staff.id}/score`} className="text-primary-700">
                    勤務スコア確認
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
